import { render, staticRenderFns } from "./ModalEdicioEnquesta.vue?vue&type=template&id=33800d64&"
import script from "./ModalEdicioEnquesta.vue?vue&type=script&lang=js&"
export * from "./ModalEdicioEnquesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports